<script setup lang="ts">
import Field from './Field.vue';
import { fieldPropDefs, useFieldProps } from './props';

const props = defineProps(fieldPropDefs);
const emit = defineEmits(['update:modelValue']);
const { id, name, fieldProps, modelValue } = useFieldProps(props, emit, {
    maxLength: 255,
});
</script>

<template>
    <Field v-bind="fieldProps">
        <InputText
            :id="id"
            v-model="modelValue"
            :name="name"
            class="field-input"
            :class="props.inputClass"
            :style="props.inputStyle"
            :required="props.required"
            v-bind="$attrs"
        />
    </Field>
</template>
